import React from 'react';
import strings from "../../localization";
import { bindActionCreators } from "redux";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as Actions from "../../actions/Actions";
import Page from '../../common/Page';
import SelectControl from '../../components/controls/SelectControl';
import IconButton from "@material-ui/core/IconButton";
import { generateFuneralsForYearsOfBurialAndSelectedGraveyards } from '../../services/report/ReportService';
import { downloadReport } from '../../util/ReviewsUtil';
import { getAllGraveyards } from '../../services/graveyard/GraveyardService';
import MultiSelect from "@khanacademy/react-multi-select";


class FuneralYearsAndSelectedGraveyardsList extends Page {

  constructor(props) {
    super(props);

    this.state = {
      graveyards: [],
      data: {
        graveyard: { value: "none" },
      },
      selected: [],
    }

  }


  fetchData() {
    let data = {
      graveyard: this.state.data.graveyard ? this.state.data.value : "",
      generate: false,
      searchParam: this.state.searchData.search,
      page: this.state.searchData.page - 1,
      size: this.state.searchData.perPage,
      companyId: this.state.companyId,
      sort: this.state.sortBy,
    };
  }

  getGraveyards() {
    getAllGraveyards().then(response => {
      let graveyardCodes = [];
      for (let obj of response.data.entities) {
        graveyardCodes.push({
          label: obj.code + " - " + obj.name,
          value: obj.name,
          code: obj.code
        });
      }

      this.setState({ graveyards: graveyardCodes });
    });
  }

  componentDidMount() {
    this.setState({
      companyId: this.props.auth.user.company.id,
    }, () => {
      this.fetchData();
      this.getGraveyards();
    });
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
  }

  renderText() {
    let styles = {
      marginLeft: '20px',
    };
    return (
      <div style={styles}>
        <h1> {strings.review.tables.funerals.funeralsForSelectedGraveyards}</h1>
      </div>
    );
  }

  renderFilter() {
    let styles = {
      marginLeft: '20px',

    };

    return (

      <div style={styles}>
        <MultiSelect
          options={this.state.graveyards}
          selected={this.state.selected}
          onSelectedChanged={selected => {
            if (selected.length <= 10) {
              this.setState({
                selected,
                errorFlag: false
              })
            } else {
              this.setState({ errorFlag: true })
            }
          }}
          label={strings.review.tables.funerals.selectedGraveyard}
          hasSelectAll={false}
          overrideStrings={{
            selectSomeItems: strings.review.tables.funerals.selectSomeGraveyards,
            allItemsAreSelected: strings.review.tables.funerals.allGraveyardsAreSelected,
            selectAll: strings.review.tables.funerals.selectAll,
            search: strings.review.tables.funerals.search,
          }}
          onChange={this.changeData}

          name={"graveyard"}
          nameKey={"name"}
          valueKey={"value"}
          codeKey={"code"}

        />
      </div>
    );
  }

  getGraveyardCodes() {
    var graveyardCodes = [];
    var graveyards = this.state.graveyards;
    var selectedGraveyards = this.state.selected;
    var i, j;
    if (selectedGraveyards == []) {
      return graveyardCodes;
    }
    else {
      for (j = 0; j < graveyards.length; j++) {
        for (i = 0; i < selectedGraveyards.length; i++)
          if (graveyards[j].value === selectedGraveyards[i]) {
            graveyardCodes.push(graveyards[j].code);
          }

      }
      return graveyardCodes;
    }

  }

  renderButton() {

    let data = {
      graveyardCodes: this.getGraveyardCodes() ? this.getGraveyardCodes() : "",
      companyId: this.state.companyId,
      userId: this.props.auth.user.id
    };

    let styles = {
      marginLeft: '20px',
    };

    return (
      <div className="report-button" style={styles}>
        <IconButton onClick={() => this.generateFuneralsForYearsOfBurialAndSelectedGraveyards(data, strings.review.tables.funerals.funeralsListPDFNameForSelectedGraveyards)} disabled={this.state.selected.length == 0 || this.state.selected.length > 10}>
          {strings.review.buttons.generateReport}
        </IconButton>
      </div>

    );
  }

  generateFuneralsForYearsOfBurialAndSelectedGraveyards(data, value) {

    generateFuneralsForYearsOfBurialAndSelectedGraveyards(data).then(response => {
      if (!response.ok) {

        return;
      }

      this.props.enqueueSnackbar(strings.review.tables.funerals.funeralsListPDF, { variant: 'success' });
      downloadReport(response, value);
    })

  }

  render() {
    return (
      <div>
        {
          this.renderText()
        }
        {this.state.errorFlag &&
          <div className="multi-select-error">{strings.review.tables.funerals.multiSelectError}</div>
        }
        {
          this.renderFilter()
        }
        {
          this.renderButton()
        }


      </div>
    );
  }

}







function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(FuneralYearsAndSelectedGraveyardsList)));
